import { GoogleSheetsServiceComponent } from './GoogleSheetsServiceComponent';
export const GoogleSheetsReconnectionConfig = {
  serviceComponent: GoogleSheetsServiceComponent
};